import { http, toQuery } from '@/lib/apiClient';

export interface PagedResult<T> { page: number; pageSize: number; totalCount: number; items: T[] }
export interface AuditLogDto { id: number; entityType: string; entityId: string; action: string; performedBy: string; performedAt: string; oldValues: string | null; newValues: string | null; ipAddress: string }
export interface SecurityAuditLogDto { id: number; userId: string | null; username: string; eventType: string; outcome: string; occurredAt: string; ipAddress: string; userAgent: string; details: string | null }

export const auditsApi = {
  business: (query: Record<string, string | number | undefined>) => http.get<PagedResult<AuditLogDto>>(`/api/v1/audit-logs${toQuery(query)}`),
  security: (query: Record<string, string | number | undefined>) => http.get<PagedResult<SecurityAuditLogDto>>(`/api/v1/security-audit-logs${toQuery(query)}`),
};
